











































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
@Component
export default class AdComponent extends Vue {
    @Prop()
    private small?: boolean;
    @Prop()
    private medium?: boolean;
    @Prop()
    private lMedium?: boolean;
    @Prop()
    private large?: boolean;

    private rand: number = 0;

    private sm: boolean = false;
    private md: boolean = false;
    private lm: boolean = false;
    private lg: boolean = false;

    private mounted() {
        if (this.small) {
            this.rand = getRandomInt(5);
            this.sm = true;
        } else if (this.medium) {
            this.rand = getRandomInt(7);
            this.md = true;
        } else if (this.lMedium) {
            this.rand = getRandomInt(2);
            this.lm = true;
        } else if (this.large) {
            this.rand = getRandomInt(3);
            this.lg = true;
        }
    }
}

function getRandomInt(max: number) {
    return Math.floor(Math.random() * Math.floor(max));
}
